export class InquiryFilterFormFieldsLogic {
  /**
   * Mostra il filtro per stato delle domande.
   */
  static showStateSelectFilter(): boolean {
    return process.env.SHOW_INQUIRY_STATES_FILTER === 'true';
  }
}
